<template>
    <div class="experiment" ref="experimentContainer">
      <div class="experiment-header">
        <div class="section-line"></div>
        <div class="header-content">
          <h2 class="experiment-title">{{ title }}</h2>
          <p class="experiment-description">{{ description }}</p>
          <div class="experiment-label">{{ label }} • {{ year }}</div>
        </div>
      </div>
      
      <div v-if="title === 'Postal'" class="full-width-container">
        <InfiniteCarousel2 />
      </div>

      <div v-if="title === 'Postal'" class="less-than-full-width-container">
        <div class="media-item">
          <VideoGlow v-if="isVisible" src="/figures/lore/complementary/postal-2.mp4" />
        </div>
      </div>
      
      <div class="media-grid" :class="{ 'two-column': items.length === 2 }" v-if="title !== 'Postal'">
        <div v-for="(item, index) in items" :key="index" class="media-item">
            <VideoGlow v-if="isVideo(item) && isVisible" :src="item" />
            <ImageGlow v-else-if="isVisible" :src="item" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ImageGlow from './ImageGlow.vue'
  import VideoGlow from './VideoGlow.vue'
  import InfiniteCarousel2 from '../InfiniteCarousel2.vue'
  
  export default {
    name: 'Experiment',
    components: {
      ImageGlow,
      VideoGlow,
      InfiniteCarousel2
    },
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      year: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
    },
    data() {
        return {
        isVisible: false
        }
    },

    mounted() {
        const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.isVisible = true;
                    observer.disconnect(); // Stop observing once visible
                }
            }, {
            root: null,
            rootMargin: '400% 0px', // Start loading when within 4 viewheights of viewport
            threshold: 0
        });

        observer.observe(this.$refs.experimentContainer);
    },
    computed: {
        hasFullWidthComponent() {
            return !!this.customComponent
        }
    },
    methods: {
      isVideo(filepath) {
        return filepath.match(/\.(mp4|webm|mov)$/i)
      }
    }
  }
  </script>
  
  <style>

  .full-width-container {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow: hidden;
  }

  .less-than-full-width-container {
    width: 100%;
    padding: 0 15vw;
    box-sizing: border-box;
    position: relative;
    margin-top: 4rem;
  }

  .full-width-container .marquees {
    width: 200vw;
  }

  .experiment {
    position: relative;
    margin: 160px 0;
  }
  
  .experiment-header {
    position: relative;
    margin-bottom: 48px;
  }
  
  .section-line {
    position: absolute;
    left: -2000px; /* Extends well beyond screen */
    width: 2000px;
    height: 7px;
    background: #ffffff;
    border-radius: 20px;
    top: 27px; /* Aligns with title */
  }
  
  .header-content {
    margin-left: 4rem;
  }
  
  .experiment-title {
    font-family: "Asimov", sans-serif;
    font-size: 4.8rem;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.05em;
  }
  
  .experiment-description {
    font-family: "Untitled Serif", serif;
    font-size: 32px;
    line-height: 1.2;
    color: #DFDFDF;
    margin: 16px 0;
    max-width: 800px;
  }
  
  .experiment-label {
    font-family: "Untitled Sans", sans-serif;
    font-size: 2rem;
    font-weight: 500;
    color: #7E7E7E;
  }
  
  .media-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-top: 32px;
  }

  .media-grid.full-width {
  grid-template-columns: 1fr;
  max-width: 100%;
  width: 100%;
}

.media-grid.full-width > * {
  width: 100%;
}

  .media-grid.two-column {
  grid-template-columns: repeat(2, 1fr);
}
  
  .media-item {
    width: 100%;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.8rem;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    .media-grid,
    .media-grid.two-column {
        grid-template-columns: 1fr;
    }
    
    .section-line {
      left: -100vw;
      width: 100vw;
    }

    .less-than-full-width-container {
        width: 100%;
        padding: 0;
    }
  }
  </style>